import { render, staticRenderFns } from "./PageIntro.vue?vue&type=template&id=261d767e&scoped=true&"
import script from "./PageIntro.vue?vue&type=script&lang=js&"
export * from "./PageIntro.vue?vue&type=script&lang=js&"
import style0 from "./PageIntro.vue?vue&type=style&index=0&id=261d767e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261d767e",
  null
  
)

export default component.exports